const contracts = [
  { id: "LEGIC", name: "LECIGIMON" },
  { id: "PARKCRONO", name: "CRONO PAR" },
  { id: "PARKDMINE", name: "D MINE" },
  { id: "PARKSOCO", name: "SO CONNECT" },
  { id: "PARKDIET", name: "DIÉTÉTIS" },
  { id: "PARKTELE", name: "TÉLÉSIS" },
  { id: "PARKINT", name: "INTENSIS" },
];

export default contracts;
